import { Typography } from '@mui/material';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import { getRelativeTime } from 'src/compass/shared/util/casMoment';

type RenderInsuredNameProps = ICasRenderCellProps & {
  onClick: VoidFunction;
};

export default function RenderInsuredName({ row, onClick }: RenderInsuredNameProps) {
  return (
    <>
      <CasLink onClick={onClick}>{row.insuredName}</CasLink>
      {row?.claimCheckedOutDate && (
        <Typography variant="caption" component="div" sx={{ backgroundColor: 'yellow' }} >
          Checked out to <b>{row?.checkedOut}</b> {getRelativeTime(row.claimCheckedOutDate)}
        </Typography>
      )}
    </>
  );
}
